module.exports = __webpack_public_path__ + "img/play2.022aff91.png";